import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles/createTheme';

export const FIT: SxProps<Theme> = {
  '@media print': {
    p: 0,
    width: '100%',
    height: '100%'
  }
} as const;
export const SHOW: SxProps<Theme> = {
  '@media print': {
    display: 'block',
    pageBreakInside: 'avoid',
    pageBreakBefore: 'avoid',
    pageBreakAfter: 'avoid'
  }
} as const;
export const HIDE: SxProps<Theme> = {
  '@media print': {
    display: 'none'
  }
} as const;
export const BASE_HEADER: SxProps<Theme> = {
  '@media print': {
    px: 12.5
  }
} as const;
export const MAIN_CONTAINER: SxProps<Theme> = {
  mb: 12
} as const;
export const GENERAL_CONTAINER: SxProps<Theme> = {
  mb: 2,
  py: 2
} as const;
export const FORM_CONTAINER: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: 1,
  py: 2
} as const;
export const FORM_CONTAINER_COLUMN: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  gap: 1,
  pb: 2
} as const;
